import React from "react";
import { Polygon, Marker } from "react-leaflet";
import L from "leaflet";
import { useDispatch } from "react-redux";
import {
  setMapDialogData,
  setMapDialog,
} from "../../redux/actions/shared-actions";
import polylineColors from "../shared/map-polyline-colors";

/**
 * Component displaying the green corridors related data
 * Regions polygons are drawn
 * Polylines of and stops icon clusters for the lines which intersect the green corridors regions
 * @component
 * @category Components
 * @subcategory Map
 * @param {object} data the green corridors data
 */

const MapReconstructions = ({ data }) => {
  const dispatch = useDispatch();
  const defaultStyles = {
    color: polylineColors.reconstructions,
  };
  const highligth = {
    color: "darkred",
  };

  return (
    <React.Fragment>
      {data.map((site, index) => {
        return (
          <React.Fragment key={site.title + "-marker-" + index}>
            {/* Drawing the markers*/}
            <Marker
              position={[site.latitude, site.longitude]}
              icon={L.icon({
                iconUrl:
                  process.env.PUBLIC_URL +
                  `/icons/${
                    site.type == 1
                      ? "temporaryOrganization.webp"
                      : "permanentOrganization.png"
                  }`,
                iconSize: [35, 35],
                // iconAnchor: [64, 32],
              })}
              eventHandlers={{
                click: () => {
                  dispatch(setMapDialog(true));
                  dispatch(
                    setMapDialogData({
                      type: site.type,
                      id: site.title,
                      address: site.address,
                      description: site.description,
                      period:
                        site.startAt && site.endAt
                          ? { start: site.startAt, end: site.endAt }
                          : null,
                      file: site.file ? site.file : null,
                    })
                  );
                },
              }}
            />
            {
              /* Drawing the polygons*/
              site.polygons.map((polygon, index) => {
                return (
                  <Polygon
                    key={`${site.title}-polygon-${index}`}
                    positions={polygon.coordinates}
                    color={defaultStyles.color}
                    weight={5}
                    eventHandlers={{
                      click: () => {
                        dispatch(setMapDialog(true));
                        dispatch(
                          setMapDialogData({
                            type: "reconstruction",
                            id: site.title,
                            address: site.address,
                            description: site.description,
                            period:
                              site.startAt && site.endAt
                                ? { start: site.startAt, end: site.endAt }
                                : null,
                            file: site.file ? site.file : null,
                          })
                        );
                      },
                      mouseover: (e) => {
                        e.target.setStyle(highligth);
                      },
                      mouseout: (e) => {
                        e.target.setStyle(defaultStyles);
                      },
                    }}
                  />
                );
              })
            }
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};
export default React.memo(MapReconstructions);
